import React from "react";
import { Collapse, Skeleton } from "antd";
import Settings from "components/settings";
import { Localize } from "components/service";


const { Panel } = Collapse;
const renderNumber = Settings.Helpers.TranslationAiTable.renderNumber;
const renderPrice = Settings.Helpers.TranslationAiTable.renderPrice;
const languageCacheHelper = Settings.Helpers.TranslationAiLanguageCache;
const statusOrder = [
    languageCacheHelper.STATUS.ready,
    languageCacheHelper.STATUS.loaded,
    languageCacheHelper.STATUS.notRequested,
    languageCacheHelper.STATUS.static,
];

const getStatusCounts = (statuses) => (
    statuses.reduce((result, item) => ({
        ...result,
        [ item.status ]: (result[ item.status ] || 0) + 1,
    }), {})
);

const TranslationAiLanguageCacheHeader = ({ statuses }) => {
    const statusCounts = getStatusCounts(statuses);

    return (
        <div className="translation-ai-language-cache-header translation-ai-collapsible-header">
            <div className="title">
                <strong><Localize>TABLES.Title_UiLanguageCache</Localize></strong>
                <span><Localize>TABLES.Description_UiLanguageCache</Localize></span>
            </div>
            <div className="translation-ai-collapsible-actions">
                <div className="translation-ai-language-cache-summary">
                    { statusOrder
                        .filter((status) => statusCounts[ status ])
                        .map((status) => {
                            const meta = languageCacheHelper.getStatusMeta(status);

                            return (
                                <span
                                    key={ status }
                                    className={ `translation-ai-language-cache-summary-item ${ status }` }>
                                    <Localize>{ meta.label }</Localize>
                                    <strong>{ statusCounts[ status ] }</strong>
                                </span>
                            );
                        }) }
                </div>
                <span className="translation-ai-collapsible-hint">
                    <Localize>TABLES.Action_ShowDetails</Localize>
                </span>
            </div>
        </div>
    );
};

const TranslationAiLanguageCacheStatus = ({ statuses = [], loading }) => (
    <div className="translation-ai-language-cache">
        <Collapse
            bordered={ false }
            className="translation-ai-language-cache-collapse"
            expandIconPosition="right"
            ghost>
            <Panel
                key="language-cache"
                header={ <TranslationAiLanguageCacheHeader statuses={ statuses } /> }>
                <div className="translation-ai-language-cache-list">
                    { statuses.map((item) => (
                        <div className="translation-ai-language-cache-item" key={ item.slug }>
                            <div className="language">
                                <strong>{ item.label }</strong>
                                <span>{ item.short }</span>
                            </div>
                            <div className="status">
                                { languageCacheHelper.renderStatusBadge(item.status) }
                            </div>
                            <div>
                                <span className="label-text"><Localize>TABLES.Column_Title_LastRequest</Localize></span>
                                <strong>{ loading ? <Skeleton.Input active size="small" /> : languageCacheHelper.renderRequestDate(item.request) }</strong>
                            </div>
                            <div>
                                <span className="label-text"><Localize>TABLES.Column_Title_Items</Localize></span>
                                <strong>{ loading ? <Skeleton.Input active size="small" /> : renderNumber(item.request?.items_count) }</strong>
                            </div>
                            <div>
                                <span className="label-text"><Localize>TABLES.Column_Title_CacheHits</Localize></span>
                                <strong>{ loading ? <Skeleton.Input active size="small" /> : renderNumber(item.request?.cache_hit_items_count) }</strong>
                            </div>
                            <div>
                                <span className="label-text"><Localize>TABLES.Column_Title_TotalPrice</Localize></span>
                                <strong>{ loading ? <Skeleton.Input active size="small" /> : renderPrice(item.request) }</strong>
                            </div>
                        </div>
                    )) }
                </div>
            </Panel>
        </Collapse>
    </div>
);

export default TranslationAiLanguageCacheStatus;
